<template lang="html">
    <v-app>
        <div>
            <vue-headful title="슥삭" description="임시 비밀번호 발급" />
            <Navbar></Navbar>
            <v-container fluid>
                <v-layout row wrap>
                    <v-flex xs12 sm2>
                        <Tabbar :ismobile="ismobile" :pagename="pagename" :drawer="drawer" :userinfo="userinfo"></Tabbar>
                    </v-flex>
                    <v-flex :class="isMobile ? 'mx-auto mt-5 xs12': 'mx-auto mt-5 xs12 sm10'">
                        <v-container fluid class="px-5" style="min-height:1200px">
                            <v-row v-if="isMailSent == false">
                                <span class="col-12 display-1 mt-5 text-left">임시 비밀번호 발급</span>
                                <v-text-field label="이메일 입력" outlined dense hint="임시 비밀번호를 발급 받을 이메일을 입력해주세요" class="mt-2 col-4" v-model="partnerEmail"></v-text-field>
                                <v-btn class="ml-2 mt-2 blue darken-2 text-white" v-on:click="getTempPassword">발급</v-btn>
                                <span v-if="errMsg" class="col-12 mt-5 text-left caption red--text">{{errMsg}}</span>
                            </v-row>
                            

                            <v-row v-else>
                                <span class="col-12 display-1 mt-5 text-left">임시 비밀번호가 발급</span>
                                <span class="col-12 subtitle-2 mt-2 pb-1 text-left">{{partnerEmail}}로 임시비밀번호가 발급되었습니다. 로그인 후에 비밀번호를 변경해주세요.</span>
                                <v-col cols="5" class="mx-auto">
                                        <v-btn class="blue darken-2 text-white border-main-rounded30" block :height="60" outlined v-on:click="goLogin()">로그인하러가기</v-btn>
                                </v-col>
                            </v-row>
                        </v-container>
                        <Footer></Footer>
                    </v-flex>
                </v-layout>
    
            </v-container>

    
        </div>
    </v-app>
</template>

<script>
import Navbar from '../components/Navbar.vue'
import Tabbar from '../components/Tabbar.vue'
import Footer from '../components/Footer.vue'
import { mapGetters } from 'vuex'
//import Banner from '../components/Banner.vue'

export default {
    created() {
        window.addEventListener('resize', this.handleResize);
        this.handleResize()
    },
    destroyed() {
        window.removeEventListener('resize', this.handleResize);
    },
    data() {
        return {
            pagename: 11,
            window: {
                width: 0,
                height: 0
            },
            ismobile: false,

            drawer: false,
            group: null,
            partnerEmail: null,
            isMailSent: false,
            errMsg: null,

        }
    },
    computed:{
        ...mapGetters({
            userinfo: 'getUserInfo'
        })
    },
    components: {
        Navbar,
        Tabbar,
        Footer,
    },
    watch: {
        group() {
            this.drawer = false
        }
    },
    methods: {
        handleResize() {
            this.window.width = window.innerWidth;
            if (this.window.width <= 500) {
                this.ismobile = true
            } else {
                this.ismobile = false
            }
            this.window.height = window.innerHeight;
        },
        getTempPassword(){
            let postQuery = 'http://ssgsag-alb-2141317761.ap-northeast-2.elb.amazonaws.com/user/tempPassword?isPartners=1&userEmail=' + this.partnerEmail 
            this.$http.post(postQuery)
                    .then(response => {
                        if (response.data.status == 200) {
                            this.isMailSent = true
                        } else {
                            this.errMsg = '존재하지 않는 회원입니다.'
                        }
                    })
                    .catch(error => {
                        console.log('register failed', error)
                    })
        },
        goLogin(){
            window.location.href = '/login'
        }
    }
}
</script>

<style lang="css">
</style>


// WEBPACK FOOTER //
// src/pages/TempPassword.vue